import { getLocaleStore } from '@/i18n';
import { intelligentColorType, type IIntelligentColorItem, type IIntelligentEnhanceParams } from './types';

export const intelligentColors = (): IIntelligentColorItem[] => {
    const { $t } = getLocaleStore();
    return [
        // {
        //     color: '',
        //     txt: '整图',
        //     type: intelligentColorType.All,
        // },
        {
            color: '',
            icon: 'colorPicker',
            txt: $t((v) => v.mainLayer.models.config.pickColor),
            type: intelligentColorType.COLOR_PICKER,
        },
    ];
};

export const DEFAULT_INTELLIGENT_PRE_DATA: IIntelligentEnhanceParams = {
    isHslSelectAll: true,
    pickColors: '',
    color: null,
    hslPickColors: [0, 0, 0],
};

export const SMEAR_PEN_SIZE = 25;

export const DEFAULT_COLO_PARAMS = {
    hsl_hue: [],
    hsl_saturation: [],
    hsl_light: [],
};

export const COLOR_LIST = [
    '255,55,55,255', //红
    '255,155,55,255', //橙
    '244,242,25,255', //黄
    '43,132,41,255', //绿
    '70,128,128,255', //青
    '38,40,178,255', //蓝
    '162,46,126,255', //紫
    '225,155,200,255', //粉
    '0,0,0,255', //黑
    '255,255,255,255', //白
    '128,128,128,255', //灰
];

export const ALL_COLOR_LIST = ['-180', '-150', '-120', '-90', '-60', '-30', '30', '60', '90', '120', '150'];
export const PREVIEW_SIZE = 216;
export const MASK_COLOR = [73 / 255, 114 / 255, 223 / 255, 0.7];
export const FILTER_MASK_COLOR = [73 / 255, 114 / 255, 223 / 255, 0.7];
